export const PROCESS_STATUS_STEPS = [
	{ afterMs: 0, label: 'Lager PDF…' },
	{ afterMs: 2000, label: 'Sender e-post…' },
	{ afterMs: 5500, label: 'Klargjør bestillingen…' },
];

export const SUBMIT_STATUS_STEPS = [
	{
		afterMs: 0,
		withFiles: 'Laster opp skjema og vedlegg…',
		withoutFiles: 'Sender skjemaet…',
	},
	...PROCESS_STATUS_STEPS,
];

export function formatUploadStatus(hasFiles, loaded = 0, total = 0) {
	if (!hasFiles) {
		return 'Sender skjemaet…';
	}
	if (!total || total <= 0) {
		return 'Laster opp skjema og vedlegg…';
	}
	const pct = Math.min(100, Math.max(0, Math.round((loaded / total) * 100)));
	const mb = (n) => (n / (1024 * 1024)).toFixed(1).replace('.', ',');
	return `Laster opp vedlegg… ${pct} % (${mb(loaded)} av ${mb(total)} MB)`;
}

export function processStatusAt(elapsedMs) {
	let current = PROCESS_STATUS_STEPS[0].label;
	for (const step of PROCESS_STATUS_STEPS) {
		if (elapsedMs < step.afterMs) {
			break;
		}
		current = step.label;
	}
	return current;
}

export function submitStatusAt(elapsedMs, hasFiles) {
	if (elapsedMs < 1) {
		return formatUploadStatus(hasFiles, 0, 0);
	}
	return processStatusAt(elapsedMs);
}

export function newSubmissionId() {
	if (typeof crypto !== 'undefined' && crypto.randomUUID) {
		return crypto.randomUUID();
	}
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
		const n = (Math.random() * 16) | 0;
		const v = ch === 'x' ? n : (n & 0x3) | 0x8;
		return v.toString(16);
	});
}
